<template>
	<el-card class="box-card" shadow="hover">
		<div class="inputBox">
			<el-form-item
				v-if="i.ishidden == 'False'"
				:class="['inputItem', i.controltype == 'textarea'? 'col24' : 'col12']"
				:label="i.showname"
				label-width="100px"
				v-for="(i, index) in setlist"
				:key="index"
				size="mini"
			>
				<span>{{i.value}}</span>
			</el-form-item>
			
		</div>
	</el-card>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	props: {
		title:{
			type: String,
			default:''
		},
		l_mode:{
			type: String,
			default:''
		}
	},
	data() {
		return{
			setlist:[],
			orderinfo:{},
			isdetail:false
		};
	},
	mounted() {
		
	},
	methods:{
		init(param){
			if(param.orderinfo!=undefined)
				this.orderinfo=param.orderinfo;
			if(param.isdetail!=undefined)
				this.isdetail=param.isdetail;
			this.GetPageLayOut();
		},
		GetPageLayOut(){
			var that = this;
			this.$apipost.get.GetPagecolSet({ syscol:'', l_mode: this.l_mode }).then(res => {
				if (res.length > 0) {
					that.setlist = res;
					that.setpagelayout();
				}
			}).catch(e=>{
				that.GetPageLayOut();
			});
		},
		//设置页面数据
		setpagelayout() {
			var that = this;
			//包裹列表
			this.orderinfo.list.forEach(e=>{
				that.setlist.forEach(s => {
					for(var i in e.baginfo){
						if(s.colname.indexOf(i)>-1){
							s.value=e.baginfo[i];
						}
					}
					for(var i in that.orderinfo){
						if(s.colname.indexOf(i)>-1){
							s.value=that.orderinfo[i];
						}
					}
				});
			});
		}
	}
}
</script>

<style>
</style>
